<template>
    <div class="content-box bankInfo first" v-loading="dataLoading">
        <TitleTip v-if="$store.getters.userState == 1">
            <div class="content">
                还未认证，认证并签约后方可设置收款账号，
                <el-link :href="$contractRouter('/manage/contract/verify/fdd/step/1', 'url')" class="color-base underline" type="text">
                    立即认证
                </el-link>
            </div>
        </TitleTip>
        <TitleTip v-else-if="$store.getters.userState == 2">
            <div class="content">
                还未签约，签约后方可设置收款账号，
                <el-link :href="$contractRouter($store.getters.goContractSigned, 'url')" class="color-base underline" type="text">立即签约</el-link>
            </div>
        </TitleTip>
        <TitleTip v-else-if="($store.state.userType == 3 && !bankData.bankName) || ($store.state.userType == 1 && !alipayData.address)">
            <template v-if="bankData.reSubmitBankInfoFlag == 1">
                你的账号升级为了企业后，还未更新收款账号，请先更新收款账号，否则无法完成提现打款；
            </template>
            <template v-else>请尽快绑定结算账号，秀动发行将会通过绑定的账号进行结算</template>
        </TitleTip>
        <TitleTip v-else>
            <template v-if="bankData.reSubmitBankInfoFlag == 1">企业账号不支持支付宝提现，您设置过的支付宝账号不可用</template>
            <template v-else>绑定后如不能修改，请联系客服</template>
        </TitleTip>
        <div class="page-list-box">
            <el-row :gutter="30">
                <el-col v-if="displayEnterpriseAlipay || $store.state.userType == 1" :span="24">
                    <div :class="['card', 'alipay', alipayData.status == 3 ? 'on' : '', displayEnterpriseAlipay ? 'disabled' : '']">
                        <div class="hd">
                            <span class="icon icon-alipay"></span>
                            支付宝（{{ statusName(alipayData.status) }}）
                            <el-button
                                v-if="alipayData.status === 3 && alipayData.enableEdit && !displayEnterpriseAlipay"
                                @click="isAlipay = true"
                                type="text"
                                icon="el-icon-edit"
                            >
                                修改信息
                            </el-button>
                        </div>
                        <div class="bd">
                            <p v-if="isContractSigned && !alipayData.address" class="prompt">签约后可绑定</p>
                            <div class="text" v-else>
                                <el-button :disabled="!alipayData.enableEdit" v-if="alipayData.status === 4" type="text" @click="isAlipay = true">
                                    重新绑定
                                    <span class="el-icon-arrow-right"></span>
                                </el-button>
                                <p class="name" v-else-if="alipayData.status === 3">{{ alipayData.address }}</p>
                                <el-button v-else type="text" @click="isAlipay = true">
                                    立即绑定
                                    <span class="el-icon-arrow-right"></span>
                                </el-button>
                            </div>
                        </div>
                        <div class="ft">{{ $store.state.userType == 1 ? '秀动发行将会通过支付宝进行结算' : '企业用户暂不支持支付宝进行收款' }}</div>
                        <div v-if="$store.state.userType == 3" class="mask"></div>
                    </div>
                </el-col>
                <el-col v-if="$store.state.userType == 3" :span="24" style="margin-top: 30px">
                    <div :class="['card', 'bank', bankData.bankName ? 'on' : '']">
                        <div class="hd">
                            <span class="icon icon-bank"></span>
                            {{ bankData.bankName || '银行卡' }}{{ bankData.bankName ? '（已绑定）' : '（未绑定）' }}
                            <el-button
                                v-if="bankData.bankName && bankData.enableEdit"
                                @click="
                                    bankLook = false;
                                    isBank = true;
                                "
                                type="text"
                                icon="el-icon-edit"
                            >
                                修改信息
                            </el-button>
                            <el-button
                                v-if="bankData.bankName && !bankData.enableEdit"
                                @click="
                                    bankLook = true;
                                    isBank = true;
                                "
                                type="text"
                                icon="el-icon-view"
                            >
                                查看详情
                            </el-button>
                        </div>
                        <div class="bd">
                            <p v-if="isContractSigned && !bankData.bankName" class="prompt">签约后可绑定</p>
                            <div class="text" v-else>
                                <el-button v-if="!bankData.bankName" @click="isBank = true" type="text">
                                    立即绑定
                                    <span class="el-icon-arrow-right"></span>
                                </el-button>
                                <p class="name" v-if="bankData.account">
                                    {{ bankData.account.slice(0, 4) }} **** **** {{ bankData.account.slice(-4) }}
                                </p>
                            </div>
                        </div>
                        <div class="ft">秀动发行将会通过银行进行结算</div>
                    </div>
                </el-col>
            </el-row>
            <div class="qualification-text" v-if="qualificationStatus == 0">
                我们需要对合作的公司的资质进行审核，以方便监管部门审视我们的版权合作业务，立即去提交
                <router-link class="link underline" :to="$contractRouter('/manage/contract/enterprise/fdd/qualification', 'url')">
                    提交资质资料
                </router-link>
            </div>
        </div>
        <alipay :visible.sync="isAlipay" @change-success="alipayData.status = 2" @save-success="getAlipayDetail" :id="alipayData.id"></alipay>
        <bank :visible.sync="isBank" :look="bankLook" @save-success="getBankDetail"></bank>
        <!-- 支付宝回调确认 -->
    </div>
</template>

<script>
import Alipay from './components/Alipay';
import Bank from './components/Bank';

import {getQualification} from '@/api/user';
export default {
    props: {
        albumId: {
            type: [Number, String],
            default: '',
        },
    },
    components: {
        Alipay,
        Bank,
    },
    data() {
        return {
            isAlipay: false,
            isBank: false,
            alipayData: {},
            bankData: {},
            dataLoading: false,
            qualificationStatus: null,
            bankLook: false, // 银行详情查看
        };
    },
    computed: {
        displayEnterpriseAlipay() {
            const {userType} = this.$store.state;
            const {address} = this.alipayData;
            return userType == 3 && address;
        },
        isContractSigned() {
            const {verify} = this.$store.state || {};
            if (verify && verify.vip && verify.vip.isContractSigned === 0) return true;
            return false;
        },
        verify() {
            return this.$store.state.verify || {};
        },
        userInfo() {
            const {userInfo} = this.$store.state;
            return userInfo || {};
        },
    },
    mounted() {
        this.getBankDetail();
        this.getAlipayDetail();
        this.fetchQualification();
    },
    methods: {
        // 获取企业资质
        async fetchQualification() {
            const response = await getQualification();
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.qualificationStatus = result.status;
        },
        // 验证是否是支付宝认证授权回调
        isAlipayApproveCallback() {
            const {logon_id} = this.filterQueryValue();
            this.$confirm(
                `您的支付宝账号已授权本平台，请确您的支付宝授权账号 <span class="color-theme">${decodeURIComponent(logon_id)}</span>\n 是否正确？`,
                '支付宝授权',
                {
                    type: 'success',
                    dangerouslyUseHTMLString: true,
                    center: true,
                    showClose: false,
                    closeOnClickModal: false,
                }
            )
                .then(async () => {
                    this.saveAlipayApprove();
                })
                .catch(() => {
                    this.$message.error('支付宝授权信息确认失败');
                });
        },
        // 保存支付宝授权信息
        async saveAlipayApprove() {
            const {app_id, cert_verify_id, auth_code, logon_id, scope, source, state} = this.filterQueryValue();
            const response = await this.$request({
                url: '/receiving/account/save',
                method: 'POST',
                formData: false,
                data: {
                    accountType: 1,
                    address: logon_id,
                    appId: app_id,
                    authCode: auth_code,
                    logonId: logon_id,
                    scope: scope,
                    certVerifyId: cert_verify_id,
                    source: source,
                    state: state,
                    id: this.alipayData.id ? this.alipayData.id : '',
                },
            });
            const {msg} = response.data;
            // 清除授权信息
            const timeOut = setTimeout(() => {
                clearTimeout(timeOut);
                window.location.href = window.location.pathname;
            }, 1000);
            if (!response.data.state) return this.$message.error(msg || '授权信息保存失败，请稍后尝试');
            this.$message.success('恭喜您，支付宝认证成功');
        },
        // 过滤多个url参数值
        filterQueryValue() {
            let hash = decodeURIComponent(window.location.search);
            hash = hash.replace('?', '');
            return hash.split('&').reduce(function (res, item) {
                var parts = item.split('=');
                res[parts[0]] = parts[1];
                return res;
            }, {});
        },
        statusName(status) {
            if (status === 2) return '认证中';
            if (status === 4) return '认证失败';
            if (status === 3) return '已绑定';
            return '未绑定';
        },
        showBank() {
            if (this.bankData.account) this.isBank = true;
        },
        async getBankDetail() {
            const response = await this.$request({
                url: '/org/view/go_org_bank_info',
                method: 'post',
            });
            const {msg, state, result} = response.data;
            if (!state) return this.$message.error(msg || '');
            this.bankData = result || {};
        },
        async getAlipayDetail() {
            this.dataLoading = true;
            const response = await this.$request({
                url: '/receiving/account/detail',
                method: 'post',
                formData: false,
                data: {cpId: this.userInfo.id},
            });
            const {msg, state, result} = response.data;
            this.dataLoading = false;
            if (!state) return this.$message.error(msg || '');
            const {auth_code} = this.filterQueryValue();
            if (auth_code) this.isAlipayApproveCallback();
            this.alipayData = result || {};
        },
    },
};
</script>
<style lang="scss" scoped>
.bankInfo {
    .page-list-box {
        padding-top: 50px;
        padding-bottom: 100px;

        .el-col-24 {
            text-align: center;
        }
    }

    .card {
        display: inline-block;
        width: 380px;
        height: 210px;
        background: #f5f6fa;
        border-radius: 10px;
        padding: 0px;
        margin: 0px;
        text-align: left;
        position: relative;
        color: #909399;

        &.disabled {
            filter: grayscale(100%);
        }

        .mask {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0px;
            top: 0px;
            z-index: 1;
        }

        .hd {
            padding: 30px 30px 0;
            line-height: 20px;
            display: flex;
            align-items: center;

            .el-button {
                flex: 1;
                padding: 0px;
                text-align: right;
                color: #fff;
                font-size: 12px;
                margin-right: -10px;
            }

            .icon {
                background-size: cover !important;
                display: inline-block;
                margin-right: 10px;

                &.icon-alipay {
                    width: 18px;
                    height: 18px;
                    background: url('~@/assets/img/icon-alipay-off.png') no-repeat center;
                }

                &.icon-bank {
                    width: 19px;
                    height: 15px;
                    background: url('~@/assets/img/icon-bank-off.png') no-repeat center;
                }
            }
        }

        .bd {
            height: 110px;
            padding: 30px;

            .prompt {
                font-weight: 600;
                line-height: 22px;
                font-size: 22px;
            }

            .text .name {
                font-size: 22px;
            }

            .el-button {
                padding: 0px;
                font-size: 22px;
                font-weight: 600;
                color: #606266;
                line-height: 22px;
            }
        }

        .ft {
            line-height: 50px;
            padding: 0 30px;
            position: relative;
            font-weight: 400;
            color: #909399;
            font-size: 12px;

            &::before {
                position: absolute;
                content: '';
                top: 0px;
                left: 0px;
                width: 100%;
                height: 1px;
                background: linear-gradient(270deg, rgba(199, 199, 199, 0) 0%, #dddddd 100%);
                opacity: 0.4;
            }
        }

        &.bank::after {
            width: 170px;
            height: 140px;
            background: url('~@/assets/img/icon-bank-bg.png') no-repeat center;
            background-size: cover;
            position: absolute;
            right: 0px;
            bottom: 0px;
            content: '';
        }

        &.alipay::after {
            width: 170px;
            height: 140px;
            background: url('~@/assets/img/icon-alipay-bg.png') no-repeat center;
            background-size: cover;
            position: absolute;
            right: 0px;
            bottom: 0px;
            content: '';
        }

        &.on {
            color: #fff;

            .ft,
            .prompt,
            .el-button {
                color: #fff;
            }
        }

        &.alipay.on {
            background: linear-gradient(90deg, #1777ff 0%, #4492ff 100%);
            box-shadow: 0px 10px 20px 0px rgba(56, 138, 255, 0.2);
            color: #fff;

            .hd .icon.icon-alipay {
                background: url('~@/assets/img/icon-alipay-on.png') no-repeat center;
            }
        }

        &.bank.on {
            background: linear-gradient(135deg, #ff457d 0%, #ff9069 100%);
            box-shadow: 0px 10px 20px 0px rgba(255, 102, 117, 0.2);
            color: #fff;

            .hd .icon.icon-bank {
                background: url('~@/assets/img/icon-bank-on.png') no-repeat center;
            }
        }
    }
}

.qualification-text {
    color: $-text-600;
    text-align: center;
    padding-top: 40px;

    a {
        color: $-text-950;
    }
}
</style>
